export const modalPartners = () => {
    $('.btn-partners').click(function() {
        $('.partners-container').addClass('active')
    })
    
    $('.btn-partners-close').click(function() {
        $('.partners-container').removeClass('active')
    })
}

export const areaDropdown = () => {
    $('.area-menu-btn').click(function() {
        $(this).toggleClass('active')
        $('.area-menu-dropdown').toggleClass('active')
    })

    $(document).click((e) => {
        if(!$(e.target).closest('.area-menu-btn').length && !$(e.target).closest('.area-menu-dropdown').length) {
            $('.area-menu-btn').removeClass('active')
            $('.area-menu-dropdown').removeClass('active')
        }
    })

}

export const emptyElementRemove = () => {
    const $el = $('.single .single-content')

    $el.html((_, html) => {
        return html.replace(/&nbsp;/g, '')
    })
}